import React from 'react';
import PropTypes from 'prop-types';

// Modal for sending the active V3Offer to its agent. State (To / message /
// isSending) and the submit handler are owned by the parent — this component
// is presentational + form layout only.
const V3SendOfferModal = ({
  isOpen,
  onClose,
  sendTo,
  onChangeSendTo,
  sendMessage,
  onChangeSendMessage,
  isSendingOffer,
  onSubmit,
}) => {
  if (!isOpen) return null;

  return (
    <div
      className="modal d-block"
      tabIndex="-1"
      style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}
    >
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Send Offer</h5>
            <button type="button" className="close" onClick={onClose}>
              <span>&times;</span>
            </button>
          </div>
          <form onSubmit={onSubmit}>
            <div className="modal-body">
              <div className="form-group">
                <label htmlFor="send-offer-to" className="text-muted">To</label>
                <input
                  type="email"
                  id="send-offer-to"
                  value={sendTo}
                  multiple
                  className="form-control"
                  onChange={(e) => onChangeSendTo(e.target.value)}
                />
              </div>
              <p className="mb-2" style={{ fontSize: '16px' }}>
                <strong>Customize your message</strong>
              </p>
              <div className="form-group">
                <textarea
                  className="form-control"
                  value={sendMessage}
                  onChange={(e) => onChangeSendMessage(e.target.value)}
                  rows="7"
                />
              </div>
            </div>
            <div className="modal-footer">
              <a
                href="#"
                onClick={(e) => { e.preventDefault(); onClose(); }}
              >
                Cancel
              </a>
              <button
                type="submit"
                disabled={!sendTo || !sendTo.trim() || isSendingOffer}
                className="btn btn-primary ml-3"
              >
                {isSendingOffer ? 'Sending...' : 'Send'}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

V3SendOfferModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  sendTo: PropTypes.string.isRequired,
  onChangeSendTo: PropTypes.func.isRequired,
  sendMessage: PropTypes.string.isRequired,
  onChangeSendMessage: PropTypes.func.isRequired,
  isSendingOffer: PropTypes.bool,
  onSubmit: PropTypes.func.isRequired,
};

V3SendOfferModal.defaultProps = {
  isSendingOffer: false,
};

export default V3SendOfferModal;
